import {
  CustomButton,
  CustomCheckbox,
  CustomDatePicker,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomNumberInput,
  CustomSelect,
  Option,
  Text,
  useText,
} from '@src/components';
import { Collapse, Form } from 'antd';
import '@src/styles/myOrders/orderFilter.scss';
import '@src/styles/myOrders/giftOrderFilter.scss';
import {
  FilterOrderTypeValue,
  filterOrderStatus,
  filterOrderType,
  VouIdCode,
} from '@src/store/enums';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { orderGetPageList } from '@src/store/slice/orderSlice';
import dayjs from '@src/utils/day';
import iconDown from '@src/assets/icons/icon-down.svg';
import iconUp from '@src/assets/icons/icon-up.svg';
import iconFilter from '@src/assets/icons/icon-filter.svg';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import PropTypes from 'prop-types';

const { Panel } = Collapse;

function getExpandIcon() {
  return ({ isActive }) => {
    return (
      <div>
        <CustomImage className="open-close" src={isActive ? iconUp : iconDown} />
      </div>
    );
  };
}

const OrderFilter = ({ isCompliments = false, isMarket = false }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { filterObject } = useSelector((state) => state?.order);
  const { isSchool } = useSelector((state) => state?.auth);

  const dateText = useText((isCompliments || isMarket) ? 'startDate' : 'pickDate');
  const date2Text = useText((isCompliments || isMarket) ? 'endDate' : 'pickDate');
  const orderNoText = useText('orderNo');
  const chooseText = useText('choose');
  const orderTypeText = useText('orderType');
  const orderStatusText = useText('orderStatus');

  let vouId;
  if (isMarket) {
    vouId = VouIdCode.Market;
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
  } else {
    vouId = VouIdCode.Restaurant;
  }

  const handleClear = useCallback(async () => {
    form.resetFields();
    await dispatch(
      orderGetPageList({
        body: { vouId: vouId, orderCancel: false },
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  }, [dispatch, form]);

  const handleSearch = useCallback(async () => {
    try {
      const values = await form.validateFields();
      let body = {
        vouId: 1,
        orderTypeId: values?.orderTypeId || undefined,
        id: values?.id || undefined,
        orderCancel: values?.orderCancel || undefined,
        startDate: values?.startDate
          ? dayjs(values?.startDate)?.format('YYYY-MM-DDT00:00:00')
          : undefined,
        endDate: values?.endDate && dayjs(values?.endDate)?.format('YYYY-MM-DDT23:59:59'),
      };
      if (isCompliments || isMarket) {
        try {
          if (values?.orderTypeStatus) {
            body.OrderStatusName = filterOrderStatus?.filter(
              (item) => item.value === values?.orderTypeStatus,
            )[0].text;
          }
        } catch (errorx) {
          console.error(errorx);
        }
        if (isMarket) body.vouId = VouIdCode.Market;
        else body.vouId = VouIdCode.Compliments;
      }
      await dispatch(orderGetPageList({ pageNumber: 1, pageSize: 10, body }));
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, filterObject, form]);

  const disabledStartDate = (startValue) => {
    if (!form) return;
    const { endDate } = form.getFieldsValue(['endDate']);
    if (!startValue || !endDate) {
      return false;
    }
    return startValue?.startOf('day') > endDate?.startOf('day');
  };

  const disabledEndDate = (endValue) => {
    if (!form) return;
    const { startDate } = form.getFieldsValue(['startDate']);
    if (!endValue || !startDate) {
      return false;
    }
    return endValue?.startOf('day') < startDate?.startOf('day');
  };

  return (
    <div
      className={`filter-container ${(isCompliments || isMarket) ? 'gift-order-filter-container' : 'my-order-filter-container'
        }`}
    >
      <Collapse
        className="filter-collapse-card"
        ghost
        expandIconPosition="right"
        expandIcon={getExpandIcon()}
      >
        <Panel
          header={
            <div style={{ fontFamily: 'UbuntuMedium' }}>
              <CustomImage className="icon-filter" src={iconFilter} /> <Text t="addFilter" />
            </div>
          }
          key="1"
        >
          <div>
            <CustomForm
              name="filterForm"
              className="filter-form"
              autoComplete="off"
              initialValues={{
                orderCancel: false,
              }}
              layout={'horizontal'}
              form={form}
            >
              {(isCompliments || isMarket) ? (
                <div className="form-item">
                  <div
                    className="form-item-first-area"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      flexDirection: isMobil ? 'column' : 'row',
                    }}
                  >
                    <CustomFormItem
                      className="start-date-form-item"
                      label={
                        (isCompliments || isMarket) ? null : (
                          <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                            <Text t="startDate" />
                          </div>
                        )
                      }
                      name="startDate"
                    >
                      <CustomDatePicker
                        id="ticketRestaurant-myOrders-orderFilter-startDate-datePicker"
                        height={36}
                        placeholder={dateText}
                        disabledDate={() => {
                          return disabledStartDate();
                        }}
                      />
                    </CustomFormItem>
                    <CustomFormItem
                      className="start-date-form-item"
                      label={
                        (isCompliments || isMarket) ? null : (
                          <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                            <Text t="endDate" />
                          </div>
                        )
                      }
                      name="endDate"
                    >
                      <CustomDatePicker
                        id="ticketRestaurant-myOrders-orderFilter-endDate-datePicker"
                        height={36}
                        placeholder={date2Text}
                        disabledDate={() => {
                          return disabledEndDate();
                        }}
                      />
                    </CustomFormItem>
                    <CustomFormItem className="start-date-form-item" label={null} name="id">
                      <CustomNumberInput
                        id="ticketRestaurant-myOrders-orderFilter-id-numberInput"
                        autoComplete="off"
                        placeholder={orderNoText}
                        height={36}
                      />
                    </CustomFormItem>
                    <CustomFormItem
                      className="order-type-form-item"
                      label={null}
                      name="orderTypeId"
                    >
                      <CustomSelect
                        id="ticketRestaurant-myOrders-orderFilter-orderTypeId-select"
                        placeholder={orderTypeText}
                        height={36}
                      >
                        <Option
                          id="ticketRestaurant-myOrders-orderFilter-orderTypeId-all-option"
                          value={undefined}
                        >
                          <Text t="all" />
                        </Option>
                        {isSchool
                          ? filterOrderType
                            ?.filter((month) => month?.value === FilterOrderTypeValue.balanceLoad)
                            ?.map((month) => {
                              return (
                                <Option
                                  id={`ticketRestaurant-myOrders-orderFilter-orderTypeId-${month?.text}-option`}
                                  key={month?.value}
                                  value={month?.value}
                                >
                                  {month?.text}
                                </Option>
                              );
                            })
                          : filterOrderType
                            ?.filter((month) => month?.value !== FilterOrderTypeValue.balanceTransfer)
                            ?.map((month) => {
                              return (
                                <Option
                                  id={`ticketRestaurant-myOrders-orderFilter-orderTypeId-${month?.text}-option`}
                                  key={month?.value}
                                  value={month?.value}
                                >
                                  {month?.text}
                                </Option>
                              );
                            })}
                      </CustomSelect>
                    </CustomFormItem>
                    <CustomFormItem
                      className="order-type-form-item"
                      label={null}
                      name="orderTypeStatus"
                    >
                      <CustomSelect
                        id="ticketRestaurant-myOrders-orderFilter-orderTypeStatus-select"
                        placeholder={orderStatusText}
                        height={36}
                      >
                        <Option
                          id="ticketRestaurant-myOrders-orderFilter-orderTypeStatus-all-option"
                          value={undefined}
                        >
                          <Text t="all" />
                        </Option>
                        {filterOrderStatus.map((month) => {
                          return (
                            <Option
                              id={`ticketRestaurant-myOrders-orderFilter-orderTypeStatus-${month?.text}-option`}
                              key={month?.value}
                              value={month?.value}
                            >
                              {month?.text}
                            </Option>
                          );
                        })}
                      </CustomSelect>
                    </CustomFormItem>
                  </div>

                  <div className="form-footer">
                    {(isCompliments || isMarket) ? null : (
                      <CustomFormItem
                        label={false}
                        name="orderCancel"
                        className="footer-form-item"
                        valuePropName="checked"
                      >
                        <CustomCheckbox
                          id="ticketRestaurant-myOrders-orderFilter-orderCancel-checkbox"
                          className="only-cancel-order-check"
                        >
                          <Text t="showOnlyCancelledOrders" />
                        </CustomCheckbox>
                      </CustomFormItem>
                    )}
                    <div
                      className="action-buttons"
                      style={{
                        display: 'flex',
                        flex: (isCompliments || isMarket) ? 1 : null,
                        justifyContent: (isCompliments || isMarket) ? 'flex-end' : 'initial',
                      }}
                    >
                      <CustomButton
                        id="ticketRestaurant-myOrders-orderFilter-clear-btn"
                        data-testid="clear"
                        className="clear-btn"
                        onClick={handleClear}
                      >
                        <Text t="clean" />
                      </CustomButton>
                      <CustomButton
                        id="ticketRestaurant-myOrders-orderFilter-search-btn"
                        data-testid="search"
                        className="search-btn"
                        onClick={handleSearch}
                        style={{ backgroundColor: (isCompliments || isMarket) ? '#334155' : '#6b7789' }}
                      >
                        <CustomImage className="icon-search" src={iconSearchWhite} />{' '}
                        <Text t="search" />
                      </CustomButton>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form-item">
                  <div
                    className="form-item-first-area"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      flexDirection: isMobil ? 'column' : 'row',
                    }}
                  >
                    <div
                      className="form-item-filter-area-element"
                      style={{
                        width: '100%',
                        marginRight: '1rem',
                      }}
                    >
                      <CustomFormItem
                        className="name-form-item"
                        label={
                          <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                            <Text t="orderNo" />
                            <span>:</span>
                          </div>
                        }
                        name="id"
                      >
                        <CustomNumberInput
                          id="ticketRestaurant-myOrders-orderFilter-id-numberInput"
                          autoComplete="off"
                          placeholder={orderNoText}
                          height={36}
                        />
                      </CustomFormItem>
                      <CustomFormItem
                        className="order-type-form-item"
                        label={
                          <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                            <Text t="orderType" />
                            <span>:</span>
                          </div>
                        }
                        name="orderTypeId"
                      >
                        <CustomSelect
                          id="ticketRestaurant-myOrders-orderFilter-orderTypeId-select"
                          placeholder={chooseText}
                          height={36}
                        >
                          {!isSchool ? (
                            <Option
                              id="ticketRestaurant-myOrders-orderFilter-orderTypeId-all-option"
                              value={undefined}
                            >
                              <Text t="all" />
                            </Option>
                          ) : null}
                          {isSchool
                            ? filterOrderType
                              ?.filter((month) => month?.value === FilterOrderTypeValue.balanceLoad)
                              ?.map((month) => {
                                return (
                                  <Option
                                    id={`ticketRestaurant-myOrders-orderFilter-orderTypeId-${month?.text}-option`}
                                    key={month?.value}
                                    value={month?.value}
                                  >
                                    {month?.text}
                                  </Option>
                                );
                              })
                            : filterOrderType.map((month) => {
                              return (
                                <Option
                                  id={`ticketRestaurant-myOrders-orderFilter-orderTypeId-${month?.text}-option`}
                                  key={month?.value}
                                  value={month?.value}
                                >
                                  {month?.text}
                                </Option>
                              );
                            })}
                        </CustomSelect>
                      </CustomFormItem>
                    </div>
                    <div className="form-item-first-area-start-end-date">
                      <CustomFormItem
                        className="start-date-form-item"
                        label={
                          (isCompliments || isMarket) ? null : (
                            <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                              <Text t="startDate" />
                              <span>:</span>
                            </div>
                          )
                        }
                        name="startDate"
                      >
                        <CustomDatePicker
                          id="ticketRestaurant-myOrders-orderFilter-startDate-datePicker"
                          height={36}
                          placeholder={dateText}
                          disabledDate={() => {
                            return disabledStartDate();
                          }}
                        />
                      </CustomFormItem>
                      <CustomFormItem
                        className="end-date-form-item"
                        label={
                          (isCompliments || isMarket) ? null : (
                            <div style={{ fontFamily: 'UbuntuMedium, sans-serif' }}>
                              <Text t="endDate" />
                              <span>:</span>
                            </div>
                          )
                        }
                        name="endDate"
                      >
                        <CustomDatePicker
                          id="ticketRestaurant-myOrders-orderFilter-endDate-datePicker"
                          height={36}
                          placeholder={date2Text}
                          disabledDate={() => {
                            return disabledEndDate();
                          }}
                        />
                      </CustomFormItem>
                    </div>
                  </div>

                  <div className="form-footer">
                    {(isCompliments || isMarket) ? null : (
                      <CustomFormItem
                        label={false}
                        name="orderCancel"
                        className="footer-form-item"
                        valuePropName="checked"
                      >
                        <CustomCheckbox
                          id="ticketRestaurant-myOrders-orderFilter-orderCancel-checkbox"
                          className="only-cancel-order-check"
                        >
                          <Text t="showOnlyCancelledOrders" />
                        </CustomCheckbox>
                      </CustomFormItem>
                    )}
                    <div
                      className="action-buttons"
                      style={{
                        display: 'flex',
                        flex: (isCompliments || isMarket) ? 1 : null,
                        justifyContent: (isCompliments || isMarket) ? 'flex-end' : 'initial',
                      }}
                    >
                      <CustomButton
                        id="ticketRestaurant-myOrders-orderFilter-clear-btn"
                        data-testid="clear"
                        className="clear-btn"
                        onClick={handleClear}
                      >
                        <Text t="clean" />
                      </CustomButton>
                      <CustomButton
                        id="ticketRestaurant-myOrders-orderFilter-search-btn"
                        data-testid="search"
                        className="search-btn"
                        onClick={handleSearch}
                        style={{ backgroundColor: (isCompliments || isMarket) ? '#334155' : '#6b7789' }}
                      >
                        <CustomImage className="icon-search" src={iconSearchWhite} />{' '}
                        <Text t="search" />
                      </CustomButton>
                    </div>
                  </div>
                </div>
              )}
            </CustomForm>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

OrderFilter.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};
export default OrderFilter;
